import React from 'react'
import { Form, Spinner } from 'react-bootstrap'
import PositionList from '../Form/Preparation/PositionList.jsx'
import { usePickingPrepareDataState } from '../../../stores/PickingPrepareDataProvider.js'
import MetaInfoBlock from '../Form/MetaInfoBlock.jsx'

const PickingPreparationContentArea = () => {
  const {
    formErrors,
    headerData,
    resetErrorByFormKey,
    positions,
    loadedOrderData,
    setPositions,
  } = usePickingPrepareDataState()
  return (
    <Form>
      {
        !loadedOrderData
          ?
          <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
          :
          <>
            <div className='container-fluid'>
            <MetaInfoBlock headerData={headerData}/>
            <div className="mb-5" />
            <PositionList positions={positions} setPositions={setPositions} formErrors={formErrors} resetErrorByFormKey={resetErrorByFormKey} />
            </div>
          </>
      }
    </Form>
  )

}

export default PickingPreparationContentArea

